"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Button_1 = __importDefault(require("@mui/material/Button"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeIconButtonStyling_1 = require("./makeIconButtonStyling");
var IconButton = function (_a) {
    var disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, dataTestId = _a.dataTestId, variant = _a.variant;
    var styles = (0, makeIconButtonStyling_1.makeIconButtonStyling)(variant);
    var handleClick = function () {
        onClick();
    };
    return ((0, jsx_runtime_1.jsx)(Button_1.default, { disabled: disabled, onClick: handleClick, startIcon: icon, css: styles, "data-testid": dataTestId }));
};
IconButton.defaultProps = defaultProps_1.default;
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map